module.exports = __webpack_public_path__ + "img/office.21f7edda.jpg";